import * as React from 'react'
import { styled, css } from 'next-yak'

import { Link, type ExtraLinkProps } from '../Link'
import * as colors from '../../constants/colors'

export type LinkAsButtonProps = ExtraLinkProps &
  React.JSX.IntrinsicElements['button'] & {
    withBorder?: boolean
    withPadding?: boolean
  }

function LinkAsButtonComponent({
  children,
  className,
  ...buttonProps
}: LinkAsButtonProps): React.ReactElement<LinkAsButtonProps> {
  return (
    <Link as="button" className={className} {...buttonProps}>
      {children}
    </Link>
  )
}

export const LinkAsButton = styled(LinkAsButtonComponent)<LinkAsButtonProps>`
  cursor: pointer;
  background: transparent;
  border: none;

  &:focus {
    outline: none;
  }

  &:hover {
    ${({ kind = 'primary' }) =>
      kind === 'secondary' &&
      css`
        text-decoration: underline;
      `}

    ${({ withBorder }) => {
      if (withBorder) {
        return css`
          transition: 0.3s;
          border-radius: 4px;
          border: 1px solid ${colors.PRIMARY_BLUE_700};
        `
      }
    }}
  }

  ${({ withPadding = true }) => {
    if (withPadding) {
      return css`
        padding: 16px;
      `
    }
  }};

  ${({ withBorder }) => {
    if (withBorder) {
      return css`
        border-radius: 4px;
        border: 1px dashed ${colors.PRIMARY_SAND_200};
      `
    }
  }}
`
LinkAsButton.displayName = 'LinkAsButton'
